<template>
    <landlords-find
        :params="{
            landlord: $route.params.landlord
        }"
        :include="[
            'account(include:persons(include:address,identity_card,proof_of_address))'
        ]"
    >
        <div
            slot-scope="{
                data: landlord,
                error: find_error,
                has_loaded,
                find
            }"
        >
            <template v-if="!has_loaded || find_error">
                <base-loading
                    :error="find_error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="find_error"
                    :error="find_error"
                />
            </template>

            <template v-else>
                <base-alert
                    v-if="landlord.account.status !== landlord.account.consts.status.verified"
                    level="warning"
                    class="mb-6"
                >
                    <template slot="heading">Unverified Account</template>

                    <template slot="content">
                        <p>This account is unverified. Please complete account verification as soon as possible.</p>
                    </template>
                </base-alert>

                <pre>{{ landlord }}</pre>
            </template>
        </div>
    </landlords-find>
</template>

<script>
    import LandlordsFind from '../../../../../components/landlords-find'

    export default {
        components: {
            LandlordsFind
        }
    }
</script>
